<template>
  <div class="banner-section">
    <div class="banner-background">
      <img :src="bannerUrl" alt="" class="banner-background-img">
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <template v-if="!loading && title">
          <h1 class="banner-title">{{ title }}</h1>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageBanner',
  props: {
    title: {
      type: String,
      required: true
    },
    bannerUrl: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
// Banner区域
.banner-section {
  position: relative;
  height: 40vh;
  overflow: hidden;
  
  .banner-background {
    position: relative;
    width: 100%;
    height: 100%;

    .banner-background-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    
    .banner-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.2);
    }
    
    .banner-content {
      position: relative;
      z-index: 2;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: white;
      text-align: center;
      padding: 0 20px;
      
      .banner-title {
        font-size: 48px;
        font-weight: 600;
        margin: 0 0 15px 0;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
      }

      .skeleton-title {
        width: 40%;
        max-width: 520px;
        height: 48px;
        border-radius: 6px;
        background: linear-gradient(90deg, rgba(255,255,255,0.25) 25%, rgba(255,255,255,0.45) 37%, rgba(255,255,255,0.25) 63%);
        background-size: 400% 100%;
        animation: banner-skeleton-shimmer 1.2s ease-in-out infinite;
      }
    }
  }
}

@keyframes banner-skeleton-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: 0 0; }
}

// 响应式设计
@media (max-width: 768px) {
  .banner-section {
    height: 200px;
    
    .banner-content {
      .banner-title {
        font-size: 32px;
      }
    }
  }
}

@media (max-width: 480px) {
  .banner-section {
    .banner-content {
      .banner-title {
        font-size: 24px;
      }
    }
  }
}
</style>
